<div class="modal-header">
    <h4 class="modal-title">
        {{ pageMode === PageMode.create ? ("directions.add_new_subDirection" | translate) : ("directions.sub_government" | translate) }}
    </h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.close()"></button>
</div>
<div class="modal-body">
    <form class="col-12" [formGroup]="subDirectionForm">
        <adaa-form-steps [tabs]="tabs()" [showActions]="false" (currentTab)="activeTab.set($event)">
            <div
                class="tab-pane fade bg-card shadow-md rounded p-2"
                id="tab-0"
                role="tabpanel"
                [class.show]="activeTab() === 0"
                [class.active]="activeTab() === 0"
            >
                @if (pageMode !== PageMode.create) {
                    <div class="row">
                        <div class="col-12">
                            <adaa-form-input
                                [label]="'common.form.label.refcode' | translate"
                                [setValidator]="formValidation()!"
                                [invalid]="submitted && subDirectionForm.get('refCode')?.errors?.['required']"
                                formControlName="refCode"
                                controlName="refCode"
                            ></adaa-form-input>
                        </div>
                    </div>
                }
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [label]="'common.form.label.nameAE' | translate"
                            [setValidator]="formValidation()!"
                            [invalid]="submitted && subDirectionForm.get('nameAE')?.errors?.['required']"
                            formControlName="nameAE"
                            controlName="nameAE"
                        ></adaa-form-input>
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [label]="'common.form.label.nameEN' | translate"
                            [setValidator]="formValidation()!"
                            [invalid]="submitted && subDirectionForm.get('nameEN')?.errors?.['required']"
                            formControlName="nameEN"
                            controlName="nameEN"
                        ></adaa-form-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [label]="'common.form.label.descriptionAE' | translate"
                            [setValidator]="formValidation()!"
                            [invalid]="submitted && subDirectionForm.get('dscAE')?.errors?.['required']"
                            formControlName="dscAE"
                            controlName="dscAE"
                            [isTextArea]="true"
                        ></adaa-form-input>
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [label]="'common.form.label.descriptionEN' | translate"
                            [setValidator]="formValidation()!"
                            [invalid]="submitted && subDirectionForm.get('dscEN')?.errors?.['required']"
                            formControlName="dscEN"
                            controlName="dscEN"
                            [isTextArea]="true"
                        ></adaa-form-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-dropdown
                            appendTo=".modal-content"
                            [label]="'directions.team_owner' | translate"
                            [setValidator]="formValidation()!"
                            [invalid]="submitted && subDirectionForm.get('owner')?.errors?.['required']"
                            formControlName="owner"
                            controlName="owner"
                            [options]="directionsService.subStrategyOwnerGroups()"
                        />
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12 d-flex align-items-center mt-4">
                        <adaa-form-checkbox
                            [label]="'directions.is_main' | translate"
                            controlName="isMain"
                            formControlName="isMain"
                        ></adaa-form-checkbox>
                    </div>
                    <div class="col-12">
                        <adaa-form-input-file
                            label="directions.subgov_icon"
                            [onDeleteRemoveFile]="false"
                            [isDisabled]="pageMode === PageMode.view"
                            [allowedFileSize]="100024"
                            [allowedFiles]="allowedFiles()"
                            [file]="subDirectionIcon"
                            (inputChanges)="onFilechange($event)"
                        ></adaa-form-input-file>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-12 col-xs-12">
                            <adaa-form-dropdown
                                [label]="'directions.type' | translate"
                                formControlName="type"
                                controlName="type"
                                [options]="subGovDirTypes()"
                                [setValidator]="formValidation()!"
                                [invalid]="submitted && subDirectionForm.get('type')?.errors?.['required']"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="tab-1" role="tabpanel" [class.show]="activeTab() === 1" [class.active]="activeTab() === 1">
                <div class="bg-card shadow-md rounded p-2">
                    <adaa-data-table
                        #auxGovernmentDirectionsTable
                        titleHeader="directions.aux_government"
                        configKey="aux_gov_dir_conf_list"
                        [isLocalData]="true"
                        [enableExport]="false"
                        [localData]="getAuxDirections"
                        [enableViewAction]="false"
                        [enableAdd]="pageMode !== PageMode.view"
                        [enableEditAction]="pageMode !== PageMode.view"
                        [enableDeleteAction]="pageMode !== PageMode.view"
                        (addNewClicked)="addAuxDirectionClicked()"
                        (actionClicked)="manageAuxDirectionClicked($event)"
                    ></adaa-data-table>
                </div>
            </div>
        </adaa-form-steps>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">{{ "common.form.button.cancel" | translate }}</button>
    @if (pageMode !== PageMode.view) {
        <button type="button" class="btn btn-primary" (click)="save()">{{ "common.form.button.save" | translate }}</button>
    }
</div>
